module.exports = __webpack_public_path__ + "static/media/02.df9dfd87.png";